import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faUser,
  faUsers,
  faRightFromBracket,
  faArrowLeft,
  faUserShield,
  faArrowRight,
  faFileLines,
  faTools,
  faClipboardList,
  faInfoCircle,
  faUserPlus,
  faRepeat,
  faAddressBook,
  faComments,
} from "@fortawesome/free-solid-svg-icons";
import BASE_URL from '../config';
import "./Sidebar.css";

const Sidebar = ({ onToggle = () => { } }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [email, setEmail] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const fetchEmail = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const response = await fetch(`${BASE_URL}api/user/profile`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();
          setEmail(data.email);
        } else {
          console.error("Failed to fetch user profile.");
        }
      } catch (error) {
        console.error("Error fetching email:", error);
      }
    };

    fetchEmail();
  }, []);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
    onToggle(!isCollapsed);
  };

  const handleNavigation = (e, path) => {
    if (location.pathname === path) {
      e.preventDefault();
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      {/* Logo */}
      <div className="logo">
        <Link to="/">
          <img
            src="/nexorts-logo.png"
            alt="Nexorts Logo"
          />
        </Link>
      </div>

      {/* Toggle Button */}
      <div className="toggle-btn" onClick={toggleSidebar}>
        <FontAwesomeIcon
          icon={isCollapsed ? faArrowRight : faArrowLeft}
          style={{ color: "#22b98e" }}
        />
      </div>

      {/* Sidebar Menu */}
      <ul>
        <li>
          <Link to="/dashboard" onClick={(e) => handleNavigation(e, "/dashboard")}>
            <FontAwesomeIcon icon={faHouse} style={{ color: "white" }} />
            <span className="menu-text">Dashboard</span>
          </Link>
        </li>
        <li>
          <Link to="/my-tasks" onClick={(e) => handleNavigation(e, "/my-tasks")}>
            <FontAwesomeIcon icon={faClipboardList} style={{ color: "white" }} />
            <span className="menu-text">My Tasks</span>
          </Link>
        </li>
         {/* Show Utilities only for Rizwan */}
        {email === "abdulqadir8518@gmail.com" && (
          <>
        <li>
          <Link to="/bulk-task-adder" onClick={(e) => handleNavigation(e, "/bulk-task-adder")}>
            <FontAwesomeIcon icon={faClipboardList} style={{ color: "white" }} />
            <span className="menu-text">Bulk Tasks</span>
          </Link>
        </li>

        {/* Administration */}
        <li className="dropdown">
          <a href="#" data-bs-toggle="collapse" data-bs-target="#adminMenu">
            <FontAwesomeIcon icon={faUserShield} style={{ color: "white" }} />
            <span className="menu-text">Administration</span>
          </a>
        </li>
        <ul id="adminMenu" className="collapse mx-4">
          <li>
            <Link to="/pages" onClick={(e) => handleNavigation(e, "/pages")}>
              <FontAwesomeIcon icon={faFileLines} style={{ color: "white" }} />
              <span className="menu-text">Pages</span>
            </Link>
          </li>
          <li>
            <Link to="/users" onClick={(e) => handleNavigation(e, "/users")}>
              <FontAwesomeIcon icon={faUser} style={{ color: "white" }} />
              <span className="menu-text">Users</span>
            </Link>
          </li>
          <li>
            <Link to="/clients" onClick={(e) => handleNavigation(e, "/clients")}>
              <FontAwesomeIcon icon={faUsers} style={{ color: "white" }} />
              <span className="menu-text">Clients</span>
            </Link>
          </li>
          <li>
            <Link to="/admin-reoccurring" onClick={(e) => handleNavigation(e, "/admin-reoccurring")}>
              <FontAwesomeIcon icon={faRepeat} style={{ color: "white" }} />
              <span className="menu-text">Reoccurring Tasks</span>
            </Link>
          </li>
          <li>
            <Link to="/create-team" onClick={(e) => handleNavigation(e, "/create-team")}>
              <FontAwesomeIcon icon={faUserPlus} style={{ color: "white" }} />
              <span className="menu-text">Create Team</span>
            </Link>
          </li>

        </ul>

        <li>
          <Link to="/teams" onClick={(e) => handleNavigation(e, "/teams")}>
            <FontAwesomeIcon icon={faUsers} style={{ color: "white" }} />
            <span className="menu-text">Teams & Projects</span>
          </Link>
        </li>

        <li>
          <Link to="/information" onClick={(e) => handleNavigation(e, "/information")}>
            <FontAwesomeIcon icon={faInfoCircle} style={{ color: "white" }} />
            <span className="menu-text">Info</span>
          </Link>
        </li>

        <li>
          <Link to="/clients-information" onClick={(e) => handleNavigation(e, "/clients-information")}>
            <FontAwesomeIcon icon={faAddressBook} style={{ color: "white" }} />
            <span className="menu-text">Clients Information</span>
          </Link>
        </li>

        {/* Show Utilities only for Rizwan */}
        {/* {email === "rizwan@softisans.com" && (
          <> */}
            <li className="dropdown">
              <a href="#" data-bs-toggle="collapse" data-bs-target="#utilitiesMenu">
                <FontAwesomeIcon icon={faTools} style={{ color: "white" }} />
                <span className="menu-text">Utilities</span>
              </a>
            </li>
            <ul id="utilitiesMenu" className="collapse mx-4">
              <li>
                <Link to="/delete-email" onClick={(e) => handleNavigation(e, "/delete-email")}>
                  <FontAwesomeIcon icon={faFileLines} style={{ color: "white" }} />
                  <span className="menu-text">Delete Email</span>
                </Link>
              </li>
              <li>
                <Link to="/search-email" onClick={(e) => handleNavigation(e, "/search-email")}>
                  <FontAwesomeIcon icon={faFileLines} style={{ color: "white" }} />
                  <span className="menu-text">Search Email</span>
                </Link>
              </li>
              <li>
                <Link to="/domains" onClick={(e) => handleNavigation(e, "/domains")}>
                  <FontAwesomeIcon icon={faFileLines} style={{ color: "white" }} />
                  <span className="menu-text">Domains</span>
                </Link>
              </li>
              <li>
                <Link to="/database-transaction" onClick={(e) => handleNavigation(e, "/database-transaction")}>
                  <FontAwesomeIcon icon={faFileLines} style={{ color: "white" }} />
                  <span className="menu-text">Transactions</span>
                </Link>
              </li>
              <li>
                <Link to="/ongage-export" onClick={(e) => handleNavigation(e, "/ongage-export")}>
                  <FontAwesomeIcon icon={faFileLines} style={{ color: "white" }} />
                  <span className="menu-text">Ongage</span>
                </Link>
              </li>
              <li>
                <Link to="/api-stats" onClick={(e) => handleNavigation(e, "/api-stats")}>
                  <FontAwesomeIcon icon={faFileLines} style={{ color: "white" }} />
                  <span className="menu-text">API Stats</span>
                </Link>
              </li>
              <li>
                <Link to="/email-lead-extractor" onClick={(e) => handleNavigation(e, "/email-lead-extractor")}>
                  <FontAwesomeIcon icon={faFileLines} style={{ color: "white" }} />
                  <span className="menu-text">Email Lead Extractor</span>
                </Link>
              </li>
              <li>
                <Link to="/master-suppressions" onClick={(e) => handleNavigation(e, "/master-suppressions")}>
                  <FontAwesomeIcon icon={faFileLines} style={{ color: "white" }} />
                  <span className="menu-text">Master Suppressions</span>
                </Link>
              </li>
              <li>
                <Link to="/keeper" onClick={(e) => handleNavigation(e, "/keeper")}>
                  <FontAwesomeIcon icon={faFileLines} style={{ color: "white" }} />
                  <span className="menu-text">Keeper File</span>
                </Link>
              </li>
              <li>
                <Link to="/ben-ongage" onClick={(e) => handleNavigation(e, "/ben-ongage")}>
                  <FontAwesomeIcon icon={faFileLines} style={{ color: "white" }} />
                  <span className="menu-text">Ben Ongage</span>
                </Link>
              </li>
              <li>
                <Link to="/database-shrinker" onClick={(e) => handleNavigation(e, "/database-shrinker")}>
                  <FontAwesomeIcon icon={faFileLines} style={{ color: "white" }} />
                  <span className="menu-text">Database Shrinker</span>
                </Link>
              </li>
            </ul>
          </>
        )}

        <li>
          <a href="https://chat.google.com/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faComments} style={{ color: "white" }} />
            <span className="menu-text">Chat</span>
          </a>
        </li>
        <li>
          <Link to="#" onClick={handleLogout}>
            <FontAwesomeIcon icon={faRightFromBracket} style={{ color: "white" }} />
            <span className="menu-text">Logout</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
